// src/firebase.js
import { initializeApp }   from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence,
         connectAuthEmulator }                                                  from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentSingleTabManager,
         connectFirestoreEmulator }                                               from "firebase/firestore";
import { getStorage }                                                            from "firebase/storage";
import { getMessaging }                                                          from "firebase/messaging";
import { getFunctions, connectFunctionsEmulator }                                from "firebase/functions";

const firebaseConfig = {
  apiKey:            "AIzaSyBpCH8ajVXiLcoEGc7vkIm8EmTkuYCY61o",
  authDomain:        "music-class-83080.firebaseapp.com",
  projectId:         "music-class-83080",
  storageBucket:     "music-class-83080.firebasestorage.app",
  messagingSenderId: "663663281900",
  appId:             "1:663663281900:web:c320801ef06e18212607c9"
};

const app = initializeApp(firebaseConfig);

export const auth           = getAuth(app);
// Keep student logged in across browser sessions until explicit sign-out
setPersistence(auth, browserLocalPersistence);
export const db             = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentSingleTabManager() })
});
export const storage        = getStorage(app);
export const messaging      = getMessaging(app);
export const googleProvider = new GoogleAuthProvider();

// Connect to local Firebase Emulators when REACT_APP_USE_EMULATOR=true
// Set automatically by start-local.bat — never fires in production builds
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(getFunctions(app, 'us-central1'), 'localhost', 5001);
  console.log('%c🔧 Firebase Emulators Active', 'color:orange;font-weight:bold;font-size:14px');
}
